export function createSolidDropShadow(color: string, offset: number) {
  return `${offset}px ${offset}px 0 0 ${color}`;
}
